import { SVGInterface } from "../../interface";

const Edit = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M2.99902 21.0013H6.74902L17.809 9.94128L14.059 6.19128L2.99902 17.2513V21.0013ZM4.99902 18.0813L14.059 9.02128L14.979 9.94128L5.91902 19.0013H4.99902V18.0813Z"
      fill={color || "#0E171F"}
    />
    <path
      d="M18.369 3.29128C17.979 2.90128 17.349 2.90128 16.959 3.29128L15.129 5.12128L18.879 8.87128L20.709 7.04128C21.099 6.65128 21.099 6.02128 20.709 5.63128L18.369 3.29128Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default Edit;
